import React, { useState, useEffect } from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import CircularProgress from "@material-ui/core/CircularProgress";
import { Icon } from 'styles';
import strings from '../../../strings';
import { getCreditCosts } from '../../../actions/client';

const REQUEST_TYPE_NAMES = {
  'SOS_SEARCH': 'SOS',
  'LEXIS_VERIFICATION': 'ID Verify', 
  'LEXIS_BUSINESS_SEARCH': 'Business Search',
  'LEXIS_TOP_BUSINESS_REPORT': 'Full Business Report',
  'LEXIS_COMPREHENSIVE_INDIVIDUAL_REPORT': 'Comprehensive Indiv Report',
  'CREDIT_MEMO': 'Credit Memo',
  'FMCSA_SEARCH': 'FMCSA Search',
  'REPUTATION_REPORT': 'Reputation Report',
  'SOS_ALL_STATES_SEARCH': 'SOS All States Search',
  'DOCUMENT_ANALYSIS': 'AR Aging Analysis',
  'DOCUMENT_COMPARISON': 'AR Aging Trend Analysis',
  'PLAID_ASSETS_REPORT': 'Bank Transaction Analysis',
  'UCC_SEARCH': 'UCC Search',
  'START_REPUTATION_AGENT_CHAT': 'Start Reputation Agent Chat',
  'TIN_VERIFICATION': 'TIN Verification',
  'MOTUS_NAME': 'MOTUS Name Search',
  'MOTUS_DOT': 'MOTUS DOT Search',
  'HEALTHCARE_SEARCH': 'Healthcare Search',
};

export default function ViewReportCostDialog({ open, onClose, planName }) {
  const [reportCosts, setReportCosts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (open) {
      fetchCreditCosts();
    }
  }, [open]);

  const fetchCreditCosts = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await getCreditCosts();
      const formattedCosts = response.map(item => ({
        name: REQUEST_TYPE_NAMES[item.requestType] || item.requestType,
        value: item.creditCost.toString()
      }));
      setReportCosts(formattedCosts);
    } catch (err) {
      console.error('Error fetching credit costs:', err);
      setError('Failed to load credit costs');
    } finally {
      setLoading(false);
    }
  };
  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>{strings.BILLING.VIEW_REPORT_COST_TITLE}</DialogTitle>
      <DialogContent>
        <Typography variant="subtitle1" color="textSecondary" gutterBottom>
          {strings.BILLING.VIEW_REPORT_COST_SUBTITLE.replace('{planName}', planName)}
        </Typography>
        <Box mt={2} style={{ maxHeight: 300, overflowY: 'auto' }}>
          {loading ? (
            <Box display="flex" justifyContent="center" py={3}>
              <CircularProgress size={40} />
            </Box>
          ) : error ? (
            <Box textAlign="center" py={3}>
              <Typography color="error" variant="body2">
                {error}
              </Typography>
              <Button 
                onClick={fetchCreditCosts} 
                color="primary" 
                size="small" 
                style={{ marginTop: 8 }}
              >
                Retry
              </Button>
            </Box>
          ) : (
            reportCosts.map((item, idx) => (
              <Box
                key={item.name}
                display="flex"
                alignItems="center"
                justifyContent="space-between"
                border={0.5}
                borderColor="#D9D9D9"
                bgcolor="#f4f4f4"
                borderRadius={8}
                px={2}
                py={1.5}
                mb={1}
                width="100%"
              >
                <Typography variant="body2" style={{ fontWeight: 500 }}>{item.name}</Typography>
                <Box display="flex" alignItems="flex-start" gap={0.5}>
                  <Typography variant="body1" style={{ fontWeight: 700, marginRight: 4, color: "#EA6F39" }}>{item.value}</Typography>
                  <Icon folder="icons" fileName="credits.svg" />
                </Box>
              </Box>
            ))
          )}
        </Box>
      </DialogContent>
      <DialogActions style={{ padding: 16 }}>
        <Button onClick={onClose} color="primary" variant="contained">
          {strings.BILLING.VIEW_REPORT_COST_CLOSE}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
